<template>
  <div>
    <toolbar :title="pageTitle" :extended="isMobile">
      <v-layout :slot="isMobile ? 'extension' : null">
        <v-toolbar-items >
          <v-btn flat small right
                 class="toolbar-btn"
                 :to="{name: 'company.receiving.scheduled'}">
            <v-layout column class="align-center">
              <v-icon>schedule</v-icon>
              <v-progress-linear color="white"
                                 class="mt-2 mb-0"
                                 v-if="loadingLoads"
                                 :indeterminate="true">
              </v-progress-linear>
              <template v-else>
                {{scheduledLoads.length}}
              </template>
            </v-layout>
          </v-btn>
          <v-btn flat small right
                 class="toolbar-btn"
                 :to="{name: 'company.receiving.in_transit'}">
            <v-layout column class="align-center">
              <v-icon>local_shipping</v-icon>
              <v-progress-linear color="white"
                                 class="mt-2 mb-0"
                                 v-if="loadingLoads"
                                 :indeterminate="true">
              </v-progress-linear>
              <template v-else>
                {{inTransitLoads.length}}
              </template>
            </v-layout>
          </v-btn>
          <v-btn flat small right
                 class="toolbar-btn"
                 :to="{name: 'company.receiving.delivered'}">
            <v-layout column class="align-center">
              <v-icon>done</v-icon>
              <v-progress-linear color="white"
                                 class="mt-2 mb-0"
                                 v-if="loadingLoads"
                                 :indeterminate="true">
              </v-progress-linear>
              <template v-else>
                {{deliveredLoads.length}}
              </template>
            </v-layout>
          </v-btn>
          <v-btn flat small right
                 class="toolbar-btn"
                 :to="{name: 'company.receiving.arrivals'}">
            <v-layout column class="align-center">
              <v-icon>flight_land</v-icon>
              <v-progress-linear color="white"
                                 class="mt-2 mb-0"
                                 v-if="loadingLoads"
                                 :indeterminate="true">
              </v-progress-linear>
              <template v-else>
                {{ facilityFlightBoardArrivals(company).length }}
              </template>
            </v-layout>
          </v-btn>
          <v-btn flat small right
                 class="toolbar-btn"
                 :to="{name: 'company.receiving.departures'}">
            <v-layout column class="align-center">
              <v-icon>flight_takeoff</v-icon>
              <v-progress-linear color="white"
                                 class="mt-2 mb-0"
                                 v-if="loadingLoads"
                                 :indeterminate="true">
              </v-progress-linear>
              <template v-else>
                {{ facilityFlightBoardDepartures(company).length }}
              </template>
            </v-layout>
          </v-btn>
        </v-toolbar-items>
      </v-layout>
    </toolbar>

    <div class="pa-3" v-if="isMobile">
      <v-text-field v-model="search" append-icon="search"
                    class="mb-2 single-line hide-details"
                    label="Search loads">
      </v-text-field>

      <v-select
        :items="mobileSortOptions"
        v-model="sortValue"
        menu-props="auto"
        label="Sort by"
        hide-details
        append-icon="sort"
        single-line
        class="mb-2"
      ></v-select>
    </div>

    <v-card>
      <router-view :company="company" @updateLoad="onUpdateLoad"/>
    </v-card>
  </div>
</template>

<script>
import _ from 'lodash';
import Toolbar from '@/components/Toolbar';

import filterLoads from '@/mixins/filterLoads';
import bookedLoadMixin from '@/mixins/bookedLoadMixin';
import companySectionMixin from '@/mixins/companySectionMixin';
import directDispatchingMixin from '@/mixins/directDispatchingMixin';
import planningLoadGroupsMixin from '@/mixins/planningLoadGroupsMixin';
import dispatchRequestsMixin from '@/mixins/dispatchRequestsMixin';
import loadsRoutingMixin from '@/mixins/loadsRoutingMixin';
import facilityFlightBoardMixin from '@/mixins/facilityFlightBoardMixin';
import { mapGetters } from 'vuex';

export default {
  name: 'ReceivingPage',
  mixins: [
    directDispatchingMixin,
    filterLoads,
    bookedLoadMixin,
    companySectionMixin,
    dispatchRequestsMixin,
    facilityFlightBoardMixin,
    loadsRoutingMixin,
    planningLoadGroupsMixin,
  ],
  components: {
    Toolbar,
  },
  data: () => ({
    search: null,
    loadingBtn: false,
    mobileSortOptions: [
      { text: 'Sort ascending by Pickup Date', value: 'pickup_asc' },
      { text: 'Sort descending by Pickup Date', value: 'pickup_desc' },
      { text: 'Sort ascending by driver', value: 'driver_asc' },
      { text: 'Sort descending by driver', value: 'driver_desc' },
    ],
  }),
  computed: {
    _() {
      return _;
    },
    pageTitle() {
      return `${this.company.companyName} : ${this.$route.meta.title || ''}`;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    ...mapGetters('companies', {
      company: 'currentCompany',
    }),
    ...mapGetters('bookedLoads', {
      bookedLoads: 'bookedLoads',
      storeBookedLoadsCompanyId: 'companyId',
      loadingLoads: 'loadingLoads',
      bookedLoadsTime: 'timestamp',
    }),
    ...mapGetters('profiles', {
      isLtnAdmin: 'isLtnAdmin',
    }),
    ...mapGetters('plannedLoads', {
      loadingPlannedLoads: 'loadingLoads',
    }),
    loadingDispatchedDriverLoads() {
      return this.loadingDirectDispatchAssignments;
    },
    dispatchedDriverPlanHoles() {
      return this.directDispatchDriversAwaitingAssignment.length;
    },
  },
  methods: {
    loadData() {
      this.onRefresh();
    },
    onRefresh() {
      this.getBookedLoads();
    },
    getBookedLoads() {
      this.$store.dispatch('bookedLoads/getBookedLoads', this.companyId);
    },
    onUpdateLoad(loadData) {
      this.$store.dispatch('bookedLoads/updateLoadTacticalInfo', loadData);
    },
  },
  created() {
    if (this.storeBookedLoadsCompanyId !== this.companyId) {
      this.getBookedLoads();
    }
  },
};
</script>

<style>
  .toolbar-btn {
    min-width: 48px;
  }

  .toolbar-btn:not(.v-btn--active) {
    opacity: .7;
  }

  .toolbar-btn.v-btn--active {
    border-bottom: 2px solid white;
  }

  .toolbar-btn:before,
  .toolbar-btn:focus:before,
  .toolbar-btn:hover:before {
    background-color: transparent !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Companies/Loads/ReceivingPage.vue